document.addEventListener('DOMContentLoaded', function() {
    var parentDiv = document.querySelector('.woocommerce-order-details-pix');
    if (parentDiv) {
        var rows = parentDiv.querySelectorAll('tr');
        rows.forEach(function(row) {
            var header = row.querySelector('th');
            var cell = row.querySelector('td');
            if (header && cell && header.textContent.includes('Método de pagamento')) {
                cell.textContent = 'PIX';
            }
        });
    }
});